module.exports = __webpack_public_path__ + "img/drag.32648f09.svg";